export class PubSub {
  private listeners: Map<string, Set<(...args: unknown[]) => void>> = new Map()

  on(event: string, listener: (...args: unknown[]) => void): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set())
    }
    this.listeners.get(event)!.add(listener)
  }

  off(event: string, listener: (...args: unknown[]) => void): void {
    if (this.listeners.has(event)) {
      this.listeners.get(event)!.delete(listener)
    }
  }

  emit(event: string, ...args: unknown[]): void {
    if (this.listeners.has(event)) {
      this.listeners.get(event)!.forEach((listener) => listener(...args))
    }
  }
}
